<template>
    <div>
        <v-card>
            <v-card-title>
                {{nombre}}
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
                </v-card-title>
                <v-data-table
                :headers="headerss"
                :items="table"
                :search="search"
                :items-per-page="cant?cant:10"
                class="elevation-4"
                :loading="loadings?loadings:null"
                @click:row="selectItem"
                no-data-text="no hay datos"
                no-results-text="no data"
                loading-text="cargando datos ..."
            ></v-data-table>
        </v-card>
    </div>
</template>
<script>
export default {

  props:{
    nombre:'',
    table:'',
    headerss:'',
    loadings:'',
    type:'',
    cant:'',
    headerss2:'',

},

 
methods: {
  
  selectItem:function(value){
    this.$store.dispatch('selectTableAction', {'type':this.type ,'valor':value});
    this.$store.dispatch('MenuEquipo', true);
  }

},

  data () {
      return {
        search: '',
    }
  }
}
</script>
